import {db, store} from './state';

export const CHANGE_WAIT_PAGE = 'CHANGE_WAIT_PAGE';
export const FILTERS_SELECT_MAP = 'FILTERS_SELECT_MAP';
export const FILTERS_APPLY = 'FILTERS_APPLY';
export const FILTERS_CLEAN = 'FILTERS_CLEAN';
export const FILTERS_TO_LOAD_RESET = 'FILTERS_TO_LOAD_RESET';

function changeCurrentPage(nextPage) {
  return {
    type: CHANGE_WAIT_PAGE,
    value: nextPage
  }
}

function _clickToMap(map) {
  return {
    type: FILTERS_SELECT_MAP,
    value: map
  }
}

function _filtersToLoadReset() {
  return {
    type: FILTERS_TO_LOAD_RESET,
    value: {
      orm: db.orm,
    }
  }
}

export function clickToMap(map, force) {
  return dispatch => {
    dispatch(_clickToMap(map, force));
    if (force) {
      dispatch(_filtersToLoadReset());
      dispatch(applyFilters());
      dispatch(loadMore(0));
    }
  }
}

function _cleanFilter () {
  return {
    type: FILTERS_CLEAN
  }
}


export function cleanFilter () {
  return dispatch => {
    dispatch(_cleanFilter());
    dispatch(_filtersToLoadReset());
    dispatch(loadMore(0));
  };
}

export function loadMore (lastPage) {
  let nextPage = lastPage + 1;
  let map = store.getState().app.filtersToLoad.maps.join();
  db.loadList('replay', {sortable: 'true', page: nextPage, map});
  return function (dispatch) {
    dispatch(changeCurrentPage(nextPage));
  };
}

function applyFilters() {
  return {
    type: FILTERS_APPLY
  }
}

export function clickApplyFilters() {
  return (dispatch) => {
    dispatch(applyFilters());
    dispatch(_filtersToLoadReset());
    dispatch(loadMore(0));
  }
}



// WEBPACK FOOTER //
// ./src/appActions.js